<button mat-button name="menu-trigger" type="button" [matMenuTriggerFor]="menu">
  {{ mainLabelText() }}
  <mat-icon customMatSvgIcon="pct-mdi-chevron-down" iconPositionEnd />
</button>
<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    @for (menuItem of items(); track menuItem) {
      <!--      todo: change to isEmpty pipe-->
      @if (menuItem.items?.length) {
        <button
          mat-menu-item
          type="button"
          [matMenuTriggerData]="{ items: menuItem.items }"
          [matMenuTriggerFor]="subMenu"
          [name]="`menu-item-${menuItem.label}`"
        >
          @if (menuItem.icon) {
            <mat-icon [customMatSvgIcon]="menuItem.icon" />
          }
          {{ menuItem.label | resolveTranslateAbleText }}</button
        >
        <mat-menu #subMenu="matMenu">
          <ng-template let-items="items" matMenuContent>
            @for (menuItem of items; track menuItem) {
              <!-- Duplication is necessary; if we extract it into an ng-template or a component, the design breaks. -->
              @if (menuItem.routeLink | isString) {
                <button mat-menu-item type="button" [routerLink]="menuItem.routeLink">
                  @if (menuItem.icon) {
                    <mat-icon [customMatSvgIcon]="menuItem.icon" />
                  }
                  {{ menuItem.label | resolveTranslateAbleText }}
                </button>
              } @else if (menuItem.click | isFunction) {
                <button mat-menu-item type="button" (click)="menuItem.click()">
                  @if (menuItem.icon) {
                    <mat-icon [customMatSvgIcon]="menuItem.icon" />
                  }
                  {{ menuItem.label | resolveTranslateAbleText }}
                </button>
              } @else {
                <div disabled="true" mat-menu-item>
                  @if (menuItem.icon) {
                    <mat-icon [customMatSvgIcon]="menuItem.icon" />
                  }
                  {{ menuItem.label | resolveTranslateAbleText }}
                </div>
              }
            }
          </ng-template>
        </mat-menu>
      } @else if (menuItem.routeLink | isString) {
        <button mat-menu-item type="button" [routerLink]="menuItem.routeLink">
          @if (menuItem.icon) {
            <mat-icon [customMatSvgIcon]="menuItem.icon" />
          }
          {{ menuItem.label | resolveTranslateAbleText }}
        </button>
      } @else if (menuItem.click | isFunction) {
        <button mat-menu-item type="button" (click)="menuItem.click()">
          @if (menuItem.icon) {
            <mat-icon [customMatSvgIcon]="menuItem.icon" />
          }
          {{ menuItem.label | resolveTranslateAbleText }}
        </button>
      } @else {
        <div disabled="true" mat-menu-item>
          @if (menuItem.icon) {
            <mat-icon [customMatSvgIcon]="menuItem.icon" />
          }
          {{ menuItem.label | resolveTranslateAbleText }}
        </div>
      }
    }
  </ng-template>
</mat-menu>
